import styled from 'styled-components'
import Slider from 'react-slick'

const CustomSlick = styled(Slider)`
  .slick-list {
    padding: ${(props) => (props.style && props.style.padding ? props.style.padding : 'unset')};
    width: ${(props) => (props.style && props.style.width ? props.style.width : 'unset')};
  }

  button.slick-prev {
    left: ${(props) => (props.style && props.style.previousOffset ? props.style.previousOffset : 'unset')};
  }

  button.slick-next {
    right: ${(props) => (props.style && props.style.nextOffset ? props.style.nextOffset : 'unset')};
  }

  button::before {
    font-size: ${(props) => (props.style && props.style.buttonSize ? props.style.buttonSize : 'inherit')};
    padding: ${(props) => (props.style && props.style.buttonPadding ? props.style.buttonPadding : 'unset')};
  }
`

export default CustomSlick
